
import React, { useState, useEffect } from 'react';
import FormField from '../components/FormField';
import MyButton from '../components/MyButton';
import { createEmergencyContact } from '../api/user';
import { EMERGENCY_CONTACT_FIELDS } from '../utils/formConfig';
import { validateForm, createInitialFormState, loadValidationRules, loadDropdownData } from '../utils/form';
import RowColLayout from '../components/RowColLayout';
import ErrorSection from '../components/ErrorSection';
import FormRenderer from '../components/FormRenderer';
import { useForm } from '../hooks/useForm';

const EmergencyContactForm = ({ token, participantId, onSubmitted }) => {

  // const [errors, setErrors] = useState({});
  const [error, setError] = useState(null); // General API error
  const [loading, setLoading] = useState(false);

    const {
      formData,
      handleChange,
      dropdowns,
      rules,
      loading: dataLoading,
      errors: FormStateError,
      fieldErrors,
      isComplete,
      isValid,
      setFormData
    } = useForm({
      initialFields: EMERGENCY_CONTACT_FIELDS,
      loadDropdowns: loadDropdownData,
      loadRules: loadValidationRules
    });

      const isSubmitDisabled = !isComplete || !isValid || loading;

    if (dataLoading) return <p>Loading form data...</p>;
    if (FormStateError) return <p>Error loading form: {FormStateError.message}</p>;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);  // Clear previous general error
    // setErrors({});   // Clear previous field errors
    setLoading(true);

    if (!isValid) {
      setLoading(false);
      return;
    }

    try {

          // send registration_token instead of token
    const payload = {
      registration_token: token,
      participant_id: participantId,
      ...formData,
    };
    console.log("Payload: ", payload)
    
    console.log("EmergencyContactForm participantId:", participantId);
      const result = await createEmergencyContact(payload);
      // setResp(result);
      console.log("Result:", result)
      

      if (onSubmitted) onSubmitted(result);
    } catch (err) {
      const apiError = err?.response?.data;
      let message = 'No se pudo guardar el contacto de emergencia';
      if (apiError?.message) {
        message = apiError.message;
      }
      setError(message);

    } finally {
      setLoading(false);
    }
  };

  // console.log('Errores de campos EC:', errors);
  // console.log('Errores de API EC:', error);

  return (
    <section className="d-flex flex-column justify-content-center">
      <RowColLayout>
        <h3>Contacto de emergencia (requerido)</h3>
      </RowColLayout>

      <FormRenderer
        fields={EMERGENCY_CONTACT_FIELDS}
        formData={formData}
        errors={fieldErrors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        dropdowns={{ relationship: dropdowns.contact_relationship }}
        selectorMap={{ relationship: "Parentesco" }}
        // columns={1} // force single column layout
        buttonConfig={{
          mainText: "Enviar",
          loading: loading,
          loadingText: "Saving...",
          disabled: isSubmitDisabled
        }}
      />
      
      {/* error section */}
      <ErrorSection error={error} errors={fieldErrors} />

    </section>
  );
};

export default EmergencyContactForm;

